<template>
  <transition name="mini-fade">
    <div v-if="visible" class="mini-mask" @click.self="$emit('close')">
      <section
        class="mini-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="mini-title"
      >
        <button
          class="site-modal-close"
          type="button"
          aria-label="关闭小程序弹窗"
          @click="$emit('close')"
        >
          ×
        </button>

        <div class="mini-copy">
          <div class="mini-brand">
            <span class="paper-mark" aria-hidden="true">
              <i class="paper-sheet paper-sheet-back"></i>
              <i class="paper-sheet paper-sheet-front"></i>
              <i class="paper-fold"></i>
            </span>
            <strong><em>Paper</em> 智创</strong>
          </div>

          <span class="mini-eyebrow">微信小程序</span>
          <h2 id="mini-title">扫一扫，在手机端使用</h2>
          <p>打开微信扫描小程序码，随时处理文档、查看订单和下载结果。</p>

          <div class="mini-features" aria-label="小程序功能">
            <span>文档处理</span>
            <span>订单查询</span>
            <span>结果下载</span>
          </div>
          <div class="mini-tip">
            <span class="wechat-icon" aria-hidden="true">⌁</span>
            <span>请使用微信扫一扫</span>
          </div>
        </div>

        <div class="mini-qr-area">
          <div class="qr-card">
            <div class="qr-frame">
              <img src="../assets/wx_paper.jpg" alt="Paper 智创小程序码" />
            </div>
            <strong>Paper 智创小程序</strong>
            <span>微信扫码即可进入</span>
          </div>
        </div>
      </section>
    </div>
  </transition>
</template>

<script>
export default {
  name: "MiniProgramModal",
  props: {
    visible: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.mini-mask {
  position: fixed;
  inset: 0;
  z-index: 82;
  display: grid;
  place-items: center;
  padding: 24px;
  background: rgba(18, 29, 48, 0.48);
  backdrop-filter: blur(7px);
}

.mini-modal {
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1.12fr) minmax(250px, 0.88fr);
  width: min(700px, 100%);
  overflow: hidden;
  border: 1px solid rgba(211, 224, 241, 0.94);
  border-radius: 24px;
  background: #fff;
  box-shadow: 0 30px 90px rgba(18, 38, 68, 0.24);
}

.mini-copy {
  position: relative;
  padding: 36px 34px 34px;
  background: radial-gradient(
      circle at 4% 94%,
      rgba(57, 183, 163, 0.12),
      transparent 32%
    ),
    linear-gradient(145deg, #f8fbff 0%, #eef5ff 100%);
}

.mini-copy::after {
  position: absolute;
  right: 26px;
  bottom: 28px;
  width: 76px;
  height: 76px;
  border: 1px solid rgba(96, 153, 242, 0.15);
  border-radius: 50%;
  content: "";
}

.mini-brand {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 30px;
}

.mini-brand strong {
  color: #152846;
  font-size: 17px;
}

.mini-brand em {
  color: var(--brand-blue);
  font-style: normal;
}

.paper-mark {
  position: relative;
  display: inline-block;
  width: 28px;
  height: 28px;
}

.paper-sheet,
.paper-fold {
  position: absolute;
  display: block;
}

.paper-sheet-back {
  inset: 5px 0 0 5px;
  border-radius: 8px 5px 8px 5px;
  background: linear-gradient(145deg, #49bdae, #78d2c5);
  transform: rotate(5deg);
}

.paper-sheet-front {
  inset: 0 5px 5px 0;
  border-radius: 8px 5px 8px 5px;
  background: linear-gradient(
    145deg,
    var(--brand-blue-light),
    var(--brand-blue)
  );
  box-shadow: 0 6px 14px rgba(63, 130, 232, 0.2);
}

.paper-fold {
  top: 0;
  right: 5px;
  width: 8px;
  height: 8px;
  border-radius: 0 4px 0 3px;
  background: #cfe2ff;
  clip-path: polygon(0 0, 100% 100%, 0 100%);
}

.mini-eyebrow {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 0 11px;
  border: 1px solid #dbe8f8;
  border-radius: 999px;
  color: #3976c9;
  background: rgba(255, 255, 255, 0.78);
  font-size: 12px;
  font-weight: 800;
}

.mini-copy h2 {
  max-width: 330px;
  margin: 14px 0 0;
  color: #17243a;
  font-size: 28px;
  line-height: 1.3;
}

.mini-copy > p {
  max-width: 340px;
  margin: 14px 0 0;
  color: #63728a;
  font-size: 14px;
  line-height: 1.8;
}

.mini-features {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 22px;
}

.mini-features span {
  padding: 7px 11px;
  border-radius: 999px;
  color: #4f6382;
  background: rgba(255, 255, 255, 0.84);
  box-shadow: inset 0 0 0 1px rgba(209, 223, 242, 0.9);
  font-size: 12px;
}

.mini-tip {
  display: flex;
  align-items: center;
  gap: 9px;
  margin-top: 27px;
  color: #318c78;
  font-size: 13px;
  font-weight: 700;
}

.wechat-icon {
  display: grid;
  place-items: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  color: #fff;
  background: #2fb28f;
  font-size: 21px;
  font-weight: 800;
  transform: rotate(-20deg);
}

.mini-qr-area {
  display: grid;
  place-items: center;
  min-width: 0;
  padding: 64px 28px 34px;
  background: linear-gradient(160deg, #fff 0%, #fbfdff 100%);
}

.qr-card {
  display: grid;
  justify-items: center;
  width: 100%;
  text-align: center;
}

.qr-frame {
  position: relative;
  width: 224px;
  height: 224px;
  padding: 11px;
  border: 1px solid #dae7f6;
  border-radius: 20px;
  background: #f5f9ff;
  box-shadow: 0 16px 34px rgba(50, 91, 145, 0.1);
}

.qr-frame::before,
.qr-frame::after {
  position: absolute;
  width: 24px;
  height: 24px;
  content: "";
}

.qr-frame::before {
  top: 7px;
  left: 7px;
  border-top: 2px solid var(--brand-blue-light);
  border-left: 2px solid var(--brand-blue-light);
  border-radius: 7px 0 0;
}

.qr-frame::after {
  right: 7px;
  bottom: 7px;
  border-right: 2px solid var(--brand-blue-light);
  border-bottom: 2px solid var(--brand-blue-light);
  border-radius: 0 0 7px;
}

.qr-frame img {
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 12px;
  object-fit: cover;
}

.qr-card strong {
  margin-top: 17px;
  color: #263a59;
  font-size: 15px;
}

.qr-card > span {
  margin-top: 6px;
  color: #8491a5;
  font-size: 12px;
}

.mini-fade-enter-active,
.mini-fade-leave-active {
  transition: opacity 0.2s ease;
}

.mini-fade-enter-active .mini-modal,
.mini-fade-leave-active .mini-modal {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.mini-fade-enter,
.mini-fade-leave-to {
  opacity: 0;
}

.mini-fade-enter .mini-modal,
.mini-fade-leave-to .mini-modal {
  opacity: 0;
  transform: translateY(10px) scale(0.98);
}

@media (max-width: 680px) {
  .mini-mask {
    padding: 16px;
  }

  .mini-modal {
    grid-template-columns: 1fr;
    max-height: calc(100vh - 32px);
    overflow-y: auto;
    border-radius: 20px;
  }

  .mini-copy {
    padding: 28px 24px 24px;
    text-align: center;
  }

  .mini-brand,
  .mini-features,
  .mini-tip {
    justify-content: center;
  }

  .mini-brand {
    margin-bottom: 20px;
    padding-right: 36px;
  }

  .mini-copy h2,
  .mini-copy > p {
    margin-right: auto;
    margin-left: auto;
  }

  .mini-copy h2 {
    font-size: 24px;
  }

  .mini-tip {
    margin-top: 18px;
  }

  .mini-qr-area {
    padding: 24px 22px 28px;
  }

  .qr-frame {
    width: min(224px, 66vw);
    height: min(224px, 66vw);
  }
}

@media (prefers-reduced-motion: reduce) {
  .mini-fade-enter-active,
  .mini-fade-leave-active,
  .mini-fade-enter-active .mini-modal,
  .mini-fade-leave-active .mini-modal {
    transition: none;
  }
}
</style>
